import { Expose, Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

// Model

export class CruiseContactPersonModel {
  id: string;
  name: string;
  email: string;
  phone: string;
  description?: string | null;
}

export class CruiseRoomItemModel {
  id: string;
  type: string;
  size: string;
  description?: string | null;
}

export class CruiseShipsItemModel {
  id: string;
  name: string;
}

export class CruiseLiteModel extends CommonModel {
  code: string;
  name: string;
  email: string;
  phone: string;
  phone_2: string;

  @Type(() => CruiseContactPersonModel)
  contact: CruiseContactPersonModel;

  @Expose({ name: 'cruise_rooms' })
  @Type(() => CruiseRoomItemModel)
  cruiseRooms: CruiseRoomItemModel[];
}

export class CruiseModel extends CruiseLiteModel {
  preferences: string[];

  @Expose({ name: 'cruise_ships' })
  @Type(() => CruiseShipsItemModel)
  cruiseShips: CruiseShipsItemModel[];
}

// Input

export type getCruisesInput = {
  params: CommonParamInput;
};

export type getCruiseInput = {
  id: string;
};

export type CruiseContactPersonInput = {
  id?: string;
  name: string;
  email: string;
  phone: string;
  description?: string | null;
};

export type CruiseRoomItemInput = {
  id?: string;
  type: string;
  size: string;
  description?: string | null;
};

export type CruiseShipsItemInput = {
  name: string;
};

export type CruiseMutationInput = {
  // REQUIRED
  code: string;
  name: string;
  email: string;
  phone: string | null;
  phone_2: string | null;
  cruiseRooms: CruiseRoomItemInput[];
  cruiseShips: CruiseShipsItemInput[];
  contact: CruiseContactPersonInput;
  // preferences: string[];
};

export type CruiseUpdateInput = {
  cruiseId: string;
  body: CruiseMutationInput;
};

export type CruiseDeleteInput = {
  cruiseId: string;
};
